<template>
    <div class="select-type">
        <div v-show="text">
            <p>{{ text }}</p>
            <hr />
        </div>
        <div class="type-container">
            <span
                v-for="type in types"
                :key="type"
                class="type clickable text-center"
                tabindex="0"
                :data-test-id="`type-${type}`"
                @click="() => select(type)"
                @keyup.enter="select(type)"
            >
                <p class="type-label">{{ $t(`learning.admin.element.type.${type}`) }}</p>
                <br />
                <img class="type-icon" :src="icons[type]" :alt="type" />
            </span>
        </div>
        <br />
        <div class="text-right">
            <button class="btn" data-test-id="cancel" @click="cancel">
                {{ $t("learning.admin.element.details.btn.cancel") }}
            </button>
        </div>
    </div>
</template>

<script>
import article from "@/img/icons/badge_book.png";
import quiz from "@/img/icons/badge_planchette.png";
import task from "@/img/icons/badge_puzzle.png";
import video from "@/img/icons/badge_projector.png";

export default {
    props: {
        text: {
            type: String,
            default: "",
        },
    },
    // A `data` property is needed so that this file is taken into account by jest's code coverage
    // (cf. https://github.com/vuejs/vue-jest/issues/32)
    //
    data() {
        return {};
    },
    created() {
        this.types = ["article", "video", "task", "quiz"];
        this.icons = {
            article,
            quiz,
            task,
            video,
        };
    },
    methods: {
        select(type) {
            this.$emit("select", type);
        },
        cancel() {
            this.$emit("cancel");
        },
    },
};
</script>

<style scoped>
.type-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}
.type {
    width: 25%; /* Fits 4 types in one row! */
    transition: all 300ms ease-in-out;
    opacity: 0.6;
}
.type:hover {
    opacity: 1;
}
.type .type-icon {
    width: 50%;
    transition: all 300ms ease-in-out;
}
.type:hover .type-icon {
    transform: scale(1.05);
}
.type .type-label {
    margin: 0;
    text-align: center;
    font-size: 2rem;
    transition: all 300ms ease-in-out;
}
.type:hover .type-label {
    font-size: 2.2rem;
}
</style>
